/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { RestartAodRunRunActionsMutationResponse, RestartAodRunRunActionsPathParams, RestartAodRunRunActions404 } from "../models/RestartAodRunRunActions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { restartAodRunRunActions } from "../axios/restartAodRunRunActions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const restartAodRunRunActionsMutationKey = () => ["audit-reports-api", { url: '/aod-runs/:id/restart' }] as const

export type RestartAodRunRunActionsMutationKey = ReturnType<typeof restartAodRunRunActionsMutationKey>

export function restartAodRunRunActionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = restartAodRunRunActionsMutationKey()
        return mutationOptions<RestartAodRunRunActionsMutationResponse, ResponseErrorConfig<RestartAodRunRunActions404>, {id: RestartAodRunRunActionsPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return restartAodRunRunActions(id, config)
          },
        })

}

/**
 * @description Resets the run to WAITING, deletes its report, and re-enqueues processing. Allowed from COMPLETED_WITH_EXPORT, COMPLETED_WITHOUT_EXPORT, or FAILED.
 * @summary Restart a run
 * {@link /aod-runs/:id/restart}
 */
export function useRestartAodRunRunActions<TContext>(options: 
{
  mutation?: UseMutationOptions<RestartAodRunRunActionsMutationResponse, ResponseErrorConfig<RestartAodRunRunActions404>, {id: RestartAodRunRunActionsPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? restartAodRunRunActionsMutationKey()

          const baseOptions = restartAodRunRunActionsMutationOptions(config) as UseMutationOptions<RestartAodRunRunActionsMutationResponse, ResponseErrorConfig<RestartAodRunRunActions404>, {id: RestartAodRunRunActionsPathParams["id"]}, TContext>
          

          return useMutation<RestartAodRunRunActionsMutationResponse, ResponseErrorConfig<RestartAodRunRunActions404>, {id: RestartAodRunRunActionsPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<RestartAodRunRunActionsMutationResponse, ResponseErrorConfig<RestartAodRunRunActions404>, {id: RestartAodRunRunActionsPathParams["id"]}, TContext>
      
}